import React from "react";
import LazyLoad from "react-lazy-load";
export function ResizeImage(_ref) {
  var className = _ref.className,
      notLazyLoad = _ref.notLazyLoad,
      alt = _ref.alt,
      url = _ref.url,
      main_2x = _ref.main_2x,
      mobile = _ref.mobile,
      mobile_2x = _ref.mobile_2x,
      tablet = _ref.tablet,
      tablet_2x = _ref.tablet_2x;

  if (notLazyLoad) {
    return React.createElement("picture", {
      className: className
    }, React.createElement("source", {
      media: "(max-width: 767px)",
      srcSet: "".concat(mobile && mobile.url || url || "", ",\n            ").concat(mobile_2x && mobile_2x.url || url || "", " 2x")
    }), React.createElement("source", {
      media: "(max-width: 1279px)",
      srcSet: "".concat(tablet && tablet.url || url || "", ",\n            ").concat(tablet_2x && tablet_2x.url || url || "", " 2x")
    }), React.createElement("img", {
      src: url || "",
      srcSet: "".concat(url || "", ", ").concat(main_2x && main_2x.url || url || "", " 2x"),
      alt: alt || "img"
    }));
  }

  return React.createElement(LazyLoad, {
    offset: 300,
    className: className
  }, React.createElement("picture", null, React.createElement("source", {
    media: "(max-width: 767px)",
    srcSet: "".concat(mobile && mobile.url || url || "", ",\n            ").concat(mobile_2x && mobile_2x.url || url || "", " 2x")
  }), React.createElement("source", {
    media: "(max-width: 1279px)",
    srcSet: "".concat(tablet && tablet.url || url || "", ",\n            ").concat(tablet_2x && tablet_2x.url || url || "", " 2x")
  }), React.createElement("img", {
    src: url || "",
    srcSet: "".concat(url || "", ", ").concat(main_2x && main_2x.url || url || "", " 2x"),
    alt: alt || "img"
  })));
}